import { useMemo } from "react";
import { SaleItemInterface } from "../types/interfaces";

export const useItemPrice = (item?: SaleItemInterface | null) => {
  const priceData = useMemo(() => {
    if (!item) {
      return { displayPrice: 0, hasParentPrice: false, isComputed: false };
    }

    // 1. Проверяем цену самого родителя
    // Берем ПОСЛЕДНЮЮ цену из массива (или первую, если сортировка другая)
    const parentPrices = item.prices || [];
    const parentPrice =
      parentPrices.length > 0 ? parentPrices[parentPrices.length - 1].price : 0;

    if (parentPrice) {
      return {
        displayPrice: parentPrice,
        hasParentPrice: true,
        isComputed: false,
      };
    }

    // 2. Если цены родителя нет, но есть дети — суммируем их
    const children = Array.isArray(item.items) ? item.items : [];

    if (children.length > 0) {
      const computed = children.reduce((sum, kit) => {
        const childItem = kit.item || (kit as any).childItem;
        const childPrices = childItem?.prices || [];

        // Берем ПОСЛЕДНЮЮ цену у ребенка
        const childPrice =
          childPrices.length > 0
            ? childPrices[childPrices.length - 1].price
            : 0;

        return sum + childPrice * (kit.quantity || 1);
      }, 0);

      return {
        displayPrice: computed,
        hasParentPrice: false,
        isComputed: true,
      };
    }

    return {
      displayPrice: 0,
      hasParentPrice: false,
      isComputed: false,
    };
  }, [item]);

  return priceData;
};
